<template>
  <WorkflowStep :step="step" :tab-data="scenarioTabs" />
</template>

<script>
import toolbarTab from '@/utils/tabs/toolbar-tabs-enum';
import scenarioTabs from '@/utils/tabs/scenario-tabs-enum';

export default {
  data() {
    return {
      scenarioTabs,
      step: toolbarTab.EXECUTION_TAB,
    };
  },
};
</script>

<style lang="scss"></style>
